<!--搜索组件-->
<template>
  <!-- 菜单搜索（折叠时不显示） -->
  <div v-if="showSearch && !isCollapse" class="sidebar-search">
    <el-input
      v-model="searchKeyword"
      placeholder="搜索菜单..."
      :prefix-icon="Search"
      clearable
      @input="handleSearch"
      @clear="clearSearch"
    />
    <!-- 搜索结果 -->
    <div
      v-if="showSearchResults && searchResults.length > 0"
      class="search-results"
    >
      <div
        v-for="item in searchResults"
        :key="item.fullPath"
        class="search-result-item"
        @click="handleSearchSelect(item)"
      >
        <el-icon v-if="item.meta?.icon">
          <component :is="item.meta.icon" />
        </el-icon>
        <span class="search-result-title">{{ item.meta?.title || item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { useMenuStore } from '@/stores/modules/menu'
import { useRouter } from 'vue-router'
const emit = defineEmits(['search-select'])
const router = useRouter()
const menuStore = useMenuStore()
// 搜索相关状态
const searchKeyword = ref('')
const searchResults = ref<any[]>([])
const showSearchResults = ref(false)
// 搜索方法
const search = () => {
  const keyword = searchKeyword.value.trim()
  if (!keyword) {
    searchResults.value = []
    showSearchResults.value = false
    return
  }
  // 这里可以根据需要从 store 中获取所有菜单进行搜索
  const allMenus = menuStore.allMenus || []
  searchResults.value = allMenus.filter(menu => {
    const title = menu.meta?.title || menu.name || ''
    const path = menu.path || ''
    return title.includes(keyword) || path.includes(keyword)
  })
  showSearchResults.value = true
}
const handleSearch = () => {
  search()
}
const clearSearch = () => {
  searchKeyword.value = ''
  searchResults.value = []
  showSearchResults.value = false
}
const handleSelect = (item: any) => {
  if (item.meta?.external && item.meta.externalUrl) {
    window.open(item.meta.externalUrl, '_blank')
  } else if (item.fullPath) {
    emit('search-select', item.fullPath)
  }
  clearSearch()
}
</script>
<style scoped>
.sidebar-search {
  padding: 15px 12px 8px;
  background: #fff;
  box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
  border-right: 1px solid #e4e7ed;
  position: relative;
  flex-shrink: 0;
  :deep(.el-input) {
    .el-input__wrapper {
      border: 1px solid #f5f7fa;
      border-radius: 4px;
      box-shadow: none;
      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }
    }
    .el-input__inner {
      color: black;
      &::placeholder {
        color: rgba(0, 0, 0, 0.4);
      }
    }
  }
  .search-results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #304156;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-top: none;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1002;
    .search-result-item {
      padding: 8px 16px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #bfcbd9;
      &:hover {
        background: #1f2d3d;
        color: #409eff;
      }
      .search-result-title {
        flex: 1;
        margin-left: 8px;
      }
      .el-icon {
        font-size: 18px;
        color: #bfcbd9;
      }
    }
  }
}
</style>
